export const Layers = {
  Default: 0,
  Player: 1 << 0,
  Enemy:  1 << 1,
  UI:     1 << 2,
  Ground: 1 << 3
};
